// src/Redux/constants/doctorConstants.js

// Appointments
export const DOCTOR_APPOINTMENTS_REQUEST = "DOCTOR_APPOINTMENTS_REQUEST";
export const DOCTOR_APPOINTMENTS_SUCCESS = "DOCTOR_APPOINTMENTS_SUCCESS";
export const DOCTOR_APPOINTMENTS_FAIL = "DOCTOR_APPOINTMENTS_FAIL";

// Patient History
export const PATIENT_HISTORY_REQUEST = "PATIENT_HISTORY_REQUEST";
export const PATIENT_HISTORY_SUCCESS = "PATIENT_HISTORY_SUCCESS";
export const PATIENT_HISTORY_FAIL = "PATIENT_HISTORY_FAIL";
export const PATIENT_HISTORY_CLEAR = "PATIENT_HISTORY_CLEAR";

// Medicines Search
export const MEDICINES_SEARCH_REQUEST = "MEDICINES_SEARCH_REQUEST";
export const MEDICINES_SEARCH_SUCCESS = "MEDICINES_SEARCH_SUCCESS";
export const MEDICINES_SEARCH_FAIL = "MEDICINES_SEARCH_FAIL";

// Doctors List
export const DOCTORS_LIST_REQUEST = "DOCTORS_LIST_REQUEST";
export const DOCTORS_LIST_SUCCESS = "DOCTORS_LIST_SUCCESS";
export const DOCTORS_LIST_FAIL = "DOCTORS_LIST_FAIL";

// Create Medical Record
export const MEDICAL_RECORD_CREATE_REQUEST = "MEDICAL_RECORD_CREATE_REQUEST";
export const MEDICAL_RECORD_CREATE_SUCCESS = "MEDICAL_RECORD_CREATE_SUCCESS";
export const MEDICAL_RECORD_CREATE_FAIL = "MEDICAL_RECORD_CREATE_FAIL";
export const MEDICAL_RECORD_CREATE_RESET = "MEDICAL_RECORD_CREATE_RESET";

// Get Medical Record
export const MEDICAL_RECORD_GET_REQUEST = "MEDICAL_RECORD_GET_REQUEST";
export const MEDICAL_RECORD_GET_SUCCESS = "MEDICAL_RECORD_GET_SUCCESS";
export const MEDICAL_RECORD_GET_FAIL = "MEDICAL_RECORD_GET_FAIL";

// Doctor Stats
export const DOCTOR_STATS_REQUEST = "DOCTOR_STATS_REQUEST";
export const DOCTOR_STATS_SUCCESS = "DOCTOR_STATS_SUCCESS";
export const DOCTOR_STATS_FAIL = "DOCTOR_STATS_FAIL";

export const MEDICINES_SEARCH_CLEAR = "MEDICINES_SEARCH_CLEAR";

//ADDed new constants
export const PATIENT_APPOINTMENTS_SEARCH_REQUEST = "PATIENT_APPOINTMENTS_SEARCH_REQUEST";
export const PATIENT_APPOINTMENTS_SEARCH_SUCCESS = "PATIENT_APPOINTMENTS_SEARCH_SUCCESS";
export const PATIENT_APPOINTMENTS_SEARCH_FAIL = "PATIENT_APPOINTMENTS_SEARCH_FAIL";

export const MEDICAL_RECORD_UPDATE_REQUEST = "MEDICAL_RECORD_UPDATE_REQUEST";
export const MEDICAL_RECORD_UPDATE_SUCCESS = "MEDICAL_RECORD_UPDATE_SUCCESS";
export const MEDICAL_RECORD_UPDATE_FAIL = "MEDICAL_RECORD_UPDATE_FAIL";

export const REFERRAL_CREATE_REQUEST = "REFERRAL_CREATE_REQUEST";
export const REFERRAL_CREATE_SUCCESS = "REFERRAL_CREATE_SUCCESS";
export const REFERRAL_CREATE_FAIL = "REFERRAL_CREATE_FAIL";

export const REFERRAL_CONTEXT_REQUEST = "REFERRAL_CONTEXT_REQUEST";
export const REFERRAL_CONTEXT_SUCCESS = "REFERRAL_CONTEXT_SUCCESS";
export const REFERRAL_CONTEXT_FAIL = "REFERRAL_CONTEXT_FAIL";

export const DOCTOR_COMPLETED_APPOINTMENTS_REQUEST = 'DOCTOR_COMPLETED_APPOINTMENTS_REQUEST';
export const DOCTOR_COMPLETED_APPOINTMENTS_SUCCESS = 'DOCTOR_COMPLETED_APPOINTMENTS_SUCCESS';
export const DOCTOR_COMPLETED_APPOINTMENTS_FAIL = 'DOCTOR_COMPLETED_APPOINTMENTS_FAIL';

export const DOCTOR_ALL_PENDING_REQUEST = 'DOCTOR_ALL_PENDING_REQUEST';
export const DOCTOR_ALL_PENDING_SUCCESS = 'DOCTOR_ALL_PENDING_SUCCESS';
export const DOCTOR_ALL_PENDING_FAIL = 'DOCTOR_ALL_PENDING_FAIL';